const formatterNumber = (minimumFractionDigits = 0, maximumFractionDigits = 20) => {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits,
  })
}

export default formatterNumber
